'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _class, _temp, _initialiseProps;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Localize = require('../../Localize');

var _Localize2 = _interopRequireDefault(_Localize);

var _languages = require('../../../lib/languages');

var _dateFormat = require('./dateFormat');

var _DatePickerStyled = require('./DatePickerStyled');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(range);

function range(start, end) {
  return _regenerator2.default.wrap(function range$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!(start <= end)) {
            _context.next = 6;
            break;
          }

          _context.next = 3;
          return start;

        case 3:
          // eslint-disable-next-line no-param-reassign
          start += 1;
          _context.next = 0;
          break;

        case 6:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

var days = Array.from(range(1, 31)).map(function (item) {
  return {
    value: item,
    label: item
  };
});
var months = function months(shortMonth, language) {
  return Array.from(range(0, 11)).map(function (month) {
    return {
      value: month + 1,
      label: new Date(2000, month).toLocaleString(language, {
        month: shortMonth ? 'short' : 'long'
      })
    };
  });
};
var currentYear = new Date().getFullYear();
var years = function years(older16, yearsInFuture, yearsInPrevious) {
  var list = [];
  if (older16) {
    list = Array.from(range(currentYear - 24, currentYear - yearsInPrevious));
  } else {
    list = Array.from(range(currentYear - yearsInPrevious, currentYear + yearsInFuture));
  }
  return list.map(function (item) {
    return {
      value: item,
      label: item
    };
  });
};

var DatePicker = (_temp = _class = function (_React$Component) {
  _inherits(DatePicker, _React$Component);

  function DatePicker(props) {
    _classCallCheck(this, DatePicker);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var toState = function toState(_ref) {
      var day = _ref.day,
          month = _ref.month,
          year = _ref.year;
      return {
        day: days.find(function (_ref2) {
          var value = _ref2.value;
          return value === day;
        }),
        month: months(props.shortMonth, (0, _languages.getDefaultLanguage)()).find(function (_ref3) {
          var value = _ref3.value;
          return value === month;
        }),
        year: years(props.older16, props.yearsInFuture, props.yearsInPrevious).find(function (_ref4) {
          var value = _ref4.value;
          return value === year;
        })
      };
    };

    if (props.value) {
      _this.state = toState((0, _dateFormat.parse)(props.value));
    } else {
      _this.state = toState({
        day: props.withoutDay ? 1 : undefined,
        month: undefined,
        year: undefined
      });
    }
    return _this;
  }

  DatePicker.prototype.render = function render() {
    var _this2 = this;

    var _state = this.state,
        day = _state.day,
        month = _state.month,
        year = _state.year;
    var _props = this.props,
        label = _props.label,
        older16 = _props.older16,
        withoutDay = _props.withoutDay,
        invalid = _props.invalid,
        shortMonth = _props.shortMonth,
        yearsInFuture = _props.yearsInFuture,
        yearsInPrevious = _props.yearsInPrevious;

    return _react2.default.createElement(
      _Localize2.default,
      null,
      function (_ref5) {
        var translate = _ref5.translate,
            activeLanguage = _ref5.activeLanguage;
        return _react2.default.createElement(
          _DatePickerStyled.DatePickerWrap,
          null,
          _react2.default.createElement(
            'label',
            null,
            label
          ),
          !withoutDay && _react2.default.createElement(_DatePickerStyled.DatePickerSelect, {
            name: 'day',
            value: day,
            invalid: invalid,
            onChange: function onChange(event, data) {
              return _this2.handleChangeFor(event, 'day', data);
            },
            placeholder: translate('day'),
            options: days
          }),
          _react2.default.createElement(_DatePickerStyled.DatePickerSelect, {
            name: 'month',
            value: months(shortMonth, activeLanguage.code).find(function (_ref6) {
              var value = _ref6.value;
              return value === (month && month.value);
            }),
            invalid: invalid,
            onChange: function onChange(event, data) {
              return _this2.handleChangeFor(event, 'month', data);
            },
            placeholder: translate('month'),
            options: months(shortMonth, activeLanguage.code),
            className: 'month'
          }),
          _react2.default.createElement(_DatePickerStyled.DatePickerSelect, {
            name: 'year',
            value: year,
            invalid: invalid,
            onChange: function onChange(event, data) {
              return _this2.handleChangeFor(event, 'year', data);
            },
            placeholder: translate('year'),
            options: years(older16, yearsInFuture, yearsInPrevious)
          })
        );
      }
    );
  };

  return DatePicker;
}(_react2.default.Component), _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleChangeFor = function (value, name) {
    var _this3$setState;

    var props = _this3.props;

    _this3.setState((_this3$setState = {}, _this3$setState[name] = value, _this3$setState), function () {
      var _props$meta$setTouche;

      var _state2 = _this3.state,
          day = _state2.day,
          month = _state2.month,
          year = _state2.year;

      if (!day || !month || !year) return;
      if (props.meta) props.meta.setTouched((_props$meta$setTouche = {}, _props$meta$setTouche[props.name] = true, _props$meta$setTouche));
      if (props.meta) {
        props.meta.setFieldValue(props.name, (0, _dateFormat.format)({ year: year.value, month: month.value, day: day.value }));
        return;
      }
      props.onChange((0, _dateFormat.format)({ year: year.value, month: month.value, day: day.value }));
    });
  };
}, _temp);


DatePicker.propTypes = process.env.NODE_ENV !== "production" ? {
  shortMonth: _propTypes2.default.bool,
  invalid: _propTypes2.default.bool,
  withoutDay: _propTypes2.default.bool,
  value: _propTypes2.default.string,
  name: _propTypes2.default.string.isRequired,
  older16: _propTypes2.default.bool,
  yearsInFuture: _propTypes2.default.number,
  yearsInPrevious: _propTypes2.default.number,
  label: _propTypes2.default.string,
  meta: _propTypes2.default.shape({
    setFieldValue: _propTypes2.default.func.isRequired,
    setTouched: _propTypes2.default.func.isRequired
  }),
  onChange: _propTypes2.default.func.isRequired
} : {};

DatePicker.defaultProps = {
  shortMonth: false,
  invalid: false,
  withoutDay: false,
  value: null,
  older16: false,
  label: null,
  yearsInFuture: 3,
  yearsInPrevious: 0,
  meta: null
};

exports.default = DatePicker;
module.exports = exports['default'];